// extracted by mini-css-extract-plugin
export default {"subscriptionAgreement":"style__subscriptionAgreement___yo6hL"};